import { action, observable, makeObservable } from 'mobx';
import instMgmtApi from '../utils/api/instanceMgmt/instMgmtApi'
import { emptyGuid, isEmptyGuid } from '../utils/emptyGuid'
import { isEmptyStr } from '../utils/objectutils'
import { formatedDate } from '../utils/formatedDate'
import { t } from 'i18next'

class WashStore {
  constructor(rootStore) {
    makeObservable(this, {
      selectedWashStationId: observable,
      washStation: observable,
      washStationIsLoading: observable,
      loadWashStation: action,
      changeWashStation: action,
      setSelectedWashStationId: action,
      getSelectedWashStationId: action,
      setShowWashStationSelectModal: action,
      showWashStationSelectModal: observable,
      unknownWashStation: action,
      checkWashStationIsSelected: action,
      enforceInitWash: observable,
      setEnforceInitWash: action,
      openWashItemsCount: observable,
      checkIsWashStation: action,
      checkIsControlStation: action,
      checkIsRepairStation: action,
      checkWashActionIsAllowed: action,
      hideScanAfterTime: observable,
      setHideScanAfterTime: action,
      getHideScanAfterTime: action,
      createErrorCode: action,
      createInfoCode: action,
      loadOpenWashItemsCounter: action,
      checkWashStationSelection: action,
    });

    this.app = rootStore
  }
  washStation = {
    id: null,
    displayName: null,
    type: null,
    availableActions: null
  };
  openWashItemsCount = 0;
  showWashStationSelectModal = false;
  enforceInitWash = false;
  washStationIsLoading = false;
  selectedWashStationId = emptyGuid;
  hideScanAfterTime = 0;

  setShowWashStationSelectModal(value) {
    if (this.enforceInitWash) {
      value = false;
    }
    this.showWashStationSelectModal = value
  }
  setEnforceInitWash(value) {
    this.enforceInitWash = value
    if (this.enforceInitWash)
      this.setShowWashStationSelectModal(false)
  }
  setHideScanAfterTime(time) {
    let newTimeValue = (isEmptyStr(time) || parseInt(time) === 0) ? 0 : (parseInt(time) || this.hideScanAfterTime)
    let washHideScanAfterTime = newTimeValue > 0 ? Math.min(Math.max(newTimeValue, 1), 300) : 0
    localStorage.setItem(
      'washHideScanAfterTime',
      JSON.stringify(washHideScanAfterTime)
    )
    this.hideScanAfterTime = washHideScanAfterTime
  }
  getHideScanAfterTime() {
    this.hideScanAfterTime = 0
    if (localStorage.getItem('washHideScanAfterTime')) {
      let washHideScanAfterTime = parseInt(JSON.parse(
        localStorage.getItem('washHideScanAfterTime')
      ))
      if (washHideScanAfterTime) {
        this.hideScanAfterTime = washHideScanAfterTime
      }
    }
    return this.hideScanAfterTime
  }
  getSelectedWashStationId() {
    this.selectedWashStationId = emptyGuid
    if (localStorage.getItem('washSelectedStationId')) {
      let washSelectedStationId = JSON.parse(
        localStorage.getItem('washSelectedStationId')
      )
      if (!isEmptyGuid(washSelectedStationId)) {
        this.selectedWashStationId = washSelectedStationId
      }
    }
    return this.selectedWashStationId
  }
  setSelectedWashStationId(id) {
    let washSelectedStationId = id ?? emptyGuid
    localStorage.setItem(
      'washSelectedStationId',
      JSON.stringify(washSelectedStationId)
    )
    this.selectedWashStationId = washSelectedStationId
  }
  changeWashStation(station) {
    this.washStation = station
  }
  unknownWashStation() {
    this.setSelectedWashStationId(emptyGuid)
    let station = {
      id: null,
      displayName: null,
      type: null,
    };
    this.changeWashStation(station)
  }
  checkWashStationSelection() {
    if (!this.checkWashStationIsSelected()) {
      return this.setShowWashStationSelectModal(true);
    }
  }
  checkWashStationIsSelected() {
    if (isEmptyGuid(this.selectedWashStationId)) {
      return false;
    }
    return true;
  }
  checkWashActionIsAllowed(action) {
    if(!this.washStation?.availableActions)
      return false;

    var allowed = this.washStation.availableActions.find(item => item === action)
    return allowed
  }
  checkIsRepairStation() {
    return this.washStation?.type === 'repair'
  }
  checkIsControlStation() {
    return this.washStation?.type === 'control'
  }
  checkIsWashStation() {
    return this.washStation?.type === 'wash'
  }
  createErrorCode(scanCodeObj) {
    let msg = null
    let errorDetails = []
    if (!scanCodeObj) return ''
    let isValid = scanCodeObj.isValid ?? false
    if (!isValid) errorDetails.push(t('washPage:invalid'))
    if (!!isValid) {
      if (this.checkIsWashStation() && scanCodeObj.hasWashJob && scanCodeObj.wasAlreadyScaned) errorDetails.push(`${t('washPage:wasAlreadyScaned')} (${formatedDate(scanCodeObj.lastWashDate, true)})`)
      if (!scanCodeObj.hasWashJob && scanCodeObj.isInProgress) errorDetails.push(`${t('washPage:isInProgress')} (${formatedDate(scanCodeObj.lastWashDate, true)})`)
      if (this.checkIsRepairStation() && !scanCodeObj.hasRepairJob) errorDetails.push(t('washPage:hasNoRepairJob'))
      if (this.checkIsControlStation() && !scanCodeObj.hasControlJob) errorDetails.push(t('washPage:hasNoControlJob'))
    }
    if (errorDetails.length) {
      msg = errorDetails.join(' | ')
    }
    return msg
  }
  createInfoCode(scanCodeObj) {
    let msg = null
    let errorDetails = []
    if (!scanCodeObj) return ''
    let isValid = scanCodeObj.isValid ?? false
    if (!!isValid) {
      if (scanCodeObj.hasWashJob) errorDetails.push(`${t('washPage:hasWashJob')} (${formatedDate(scanCodeObj.lastWashDate, true)})`)
      if (scanCodeObj.hasRepairJob) errorDetails.push(t('washPage:hasRepairJob'))
      if (scanCodeObj.hasControlJob) errorDetails.push(t('washPage:hasControlJob'))
    }
    if (errorDetails.length) {
      msg = errorDetails.join(' | ')
    }
    return msg
  }
  async loadWashStation(force = false) {
    if (isEmptyGuid(this.selectedWashStationId)) {
      this.unknownWashStation()
      return this.washStation
    }
    if (this.washStation?.id && !force) {
      return this.washStation
    }
    if (this.washStationIsLoading) {
      await this.app.uiStore.waitUntilLoaded(100, 'app.washStore.washStationIsLoading')
      return this.washStation
    } else {
      this.washStationIsLoading = true
      try {
        let loadedStation = await instMgmtApi.getWashStation(this.selectedWashStationId)
        this.loadOpenWashItemsCounter()
        this.changeWashStation(loadedStation)
      }
      catch {
        this.unknownWashStation()
      }
      this.washStationIsLoading = false
      return this.washStation
    }
  }
  async loadOpenWashItemsCounter() {
    this.openWashItemsCount = await instMgmtApi.getOpenWashItemsCounter()
  }
}
export default WashStore
